// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"styles_scrollWrapper__03RRo","submitButton":"styles_submitButton__4nMAu","title":"styles_title__04L1h"};